module.exports = __webpack_public_path__ + "fonts/SparkasseHead_web_Rg.5a911fc2.woff";